// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountLevelSettings_container__1eYxw","rulesContainer":"AccountLevelSettings_rulesContainer__hF_uR","button":"AccountLevelSettings_button__2T4tN"};